import { getUserAttributes } from '@mb/lib/localStorage';
import { MageUserAttributes } from '@mb/types/mageUserAttributes';

type PrivateContentEventDetail = {
  data?: {
    customer: MageUserAttributes;
  };
};

const maxTries = 5;
const intervalTime = 100;

export const loadUserData = (): Promise<MageUserAttributes> =>
  new Promise((resolve, _reject) => {
    let userData: MageUserAttributes;
    let tries = 0;
    let usingEvent = false;
    // eslint-disable-next-line prefer-const
    let interval: NodeJS.Timeout;

    const onPrivateContentLoaded = (
      e: CustomEvent<PrivateContentEventDetail>,
    ) => {
      const { data } = e.detail || {};
      const customer = data?.customer;
      if (customer) {
        userData = customer;
      }
    };

    const resolveAndCleanup = (userData: MageUserAttributes) => {
      // clear event listener
      if (usingEvent) {
        window.removeEventListener(
          'private-content-loaded',
          onPrivateContentLoaded,
        );
      }
      if (interval) {
        clearInterval(interval);
      }
      resolve(userData);
    };

    interval = setInterval(() => {
      tries += 1;
      userData = userData || getUserAttributes();
      if (userData) {
        resolveAndCleanup(userData);
      } else {
        if (tries === 1) {
          // set up event listener if first attempt to retrieve from local storage failed
          window.addEventListener(
            'private-content-loaded',
            onPrivateContentLoaded,
          );
          // give event handler a chance to load data
          usingEvent = true;
          return;
        }

        if (tries >= maxTries) {
          // give caller empty object to indicate failure but avoid null reference exceptions
          // TODO: refactor without type assertion, or add comment
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          resolveAndCleanup({} as MageUserAttributes);
        }
      }
    }, intervalTime);
  });
